import { TPlant } from '../../types';

export type TP_AirHandlingUnit = {
    showTrendPanels: boolean;
    showEfficiency: boolean;
    showEfficiencyDemo: boolean;
    showSupplyDuct: boolean;
    showExhaustDuct: boolean;
    showFans: boolean;  
    showHeating: boolean;
    showCooling: boolean;
    showOperationHours: boolean;
} & TPlant

export const schema = 'AutomationApps.Plants.AirHandlingUnits.P_AirHandlingUnit';
export const modelId = 'dtmi:AutomationApps:Plants:AirHandlingUnits:P_AirHandlingUnit';
